module.exports = __webpack_public_path__ + "static/media/details-asset.b05c89a1.png";